import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../asyncInterface";
import * as actionTypes from "./actionTypes";

export function* fetchDocumentCentreDataWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
        });
        fetchArr.push(keyObj);
      }
    }
    const fetchedArr = yield all(
      fetchArr.map((each) => call(fetchAccountData, each))
    );
    yield put({
      type: actionTypes.docCentreDataSuccessType,
      payload: {
        response: fetchedArr[0].data,
        fetchPayload: fetchPayload.payload,
      },
    });
  } catch (error) {
    yield put({
      type: actionTypes.docCentreDataFailureType,
      error,
    });
  }
}

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  const data = fetchData.documentCentre.fetchAccountData(fetchPayload);
  return data;
}

export function* fetchDocumentCentreDataWatcher() {
  yield takeEvery(actionTypes.fetchDocCentreDataType, fetchDocumentCentreDataWorker);
}

export default function* documentCentreWatcher() {
  yield all([
    fork(fetchDocumentCentreDataWatcher),
  ]);
}
